/**
 * Team Trips — Hero Crossfade Alpine component
 *
 * Cycles through 10 hero frames every 3.4s with a 1.1s opacity fade.
 * Each frame div carries the `tt-kenburns` Tailwind animation for Ken-Burns
 * scale effect (A1 + A2 in SPEC_motion.md).
 *
 * Automatically disabled when `prefers-reduced-motion: reduce` is active.
 */
export default function heroCrossfade() {
    const TOTAL_FRAMES = 10;
    const INTERVAL_MS  = 3400;

    return {
        /** Index of the currently visible frame (0-based). */
        active: 0,

        /** Internal interval reference for teardown. */
        _interval: null,

        /** True when the browser has requested reduced motion. */
        _reduced: typeof window !== 'undefined'
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches,

        init() {
            if (this._reduced) {
                return;
            }

            this._interval = setInterval(() => {
                this.active = (this.active + 1) % TOTAL_FRAMES;
            }, INTERVAL_MS);
        },

        destroy() {
            if (this._interval !== null) {
                clearInterval(this._interval);
                this._interval = null;
            }
        },

        isActive(index) {
            return this.active === index;
        },
    };
}
